var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper success_base"},[_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":require("../../assets/image/secondary/notice.jpg")}})])
}]

export { render, staticRenderFns }